import { render, staticRenderFns } from "./AnnotationResultDisplayer.vue?vue&type=template&id=47ebb311&scoped=true&"
import script from "./AnnotationResultDisplayer.vue?vue&type=script&lang=js&"
export * from "./AnnotationResultDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationResultDisplayer.vue?vue&type=style&index=0&id=47ebb311&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ebb311",
  null
  
)

export default component.exports